import { Component, ElementRef, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';

import { createLocalTracks, LocalTrack, LocalVideoTrack } from 'twilio-video';

@Component({
  selector: 'app-camera',
  styleUrls: ['./camera.component.scss'],
  templateUrl: './camera.component.html',
})
export class CameraComponent implements AfterViewInit {
  @ViewChild('preview', { static: false }) previewElement: ElementRef;

  get tracks(): LocalTrack[] {
    return this.localTracks;
  }

  isInitializing: boolean = true;
  previewIsOn: boolean = false;

  private videoTrack: LocalVideoTrack;
  private audioTrack: LocalTrack;
  public localTracks: LocalTrack[] = [];

  constructor(
    private readonly renderer: Renderer2) { }

  async ngAfterViewInit() {
  }

  async initializePreview(deviceInfo?: MediaDeviceInfo) {
    if (this.previewElement && this.previewElement.nativeElement) {
      if (deviceInfo) {
        await this.initializeDevice(deviceInfo.kind, deviceInfo.deviceId);
      } else {
        await this.initializeDevice();
      }
    }
  }

  finalizePreview() {
    try {
      if (this.videoTrack) {
        this.videoTrack.stop();
        this.videoTrack.detach().forEach(element => element.remove());
      }

      this.finalizeAudioTrack();
    } catch (e) {
      console.error(e);
    }
  }

  finalizeAudioTrack() {
    try {
      if (this.audioTrack) {
        this.audioTrack.stop();
        this.audioTrack.detach().forEach(element => element.remove());
      }
    } catch (e) {
      console.error(e);
    }
  }

  private async initializeDevice(kind?: MediaDeviceKind, deviceId?: string) {
    try {
      this.isInitializing = true;

      this.finalizePreview();

      this.localTracks = kind && deviceId
        ? await this.initializeTracks(kind, deviceId)
        : await this.initializeTracks();

      this.videoTrack = this.localTracks.find(t => t.kind === 'video') as LocalVideoTrack;
      this.audioTrack = this.localTracks.find(t => t.kind === 'audioinput') as LocalTrack;

      const videoElement = this.videoTrack.attach();
      this.renderer.setStyle(videoElement, 'height', '100%');
      this.renderer.setStyle(videoElement, 'width', '100%');
      this.renderer.appendChild(this.previewElement.nativeElement, videoElement);
    } finally {
      this.isInitializing = false;
    }
  }

  private initializeTracks(kind?: MediaDeviceKind, deviceId?: string): Promise<LocalTrack> {
    if (kind) {
      switch (kind) {
        case 'audioinput':
          return createLocalTracks({ audio: { deviceId }, video: true });
        case 'videoinput':
          return createLocalTracks({ audio: true, video: { deviceId } });
      }
    }

    return createLocalTracks({ audio: true, video: true });
  }
}
